/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagine that you are organizing a workshop and need to track three supplies. Create columns for Item, Quantity, Unit cost and Line total. Use one row for each supply, and keep the quantity and unit cost as separate numeric inputs. This structure is more useful than typing a finished total into every row because you can change attendance or prices without rewriting the entire sheet.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`假设你要组织一场工作坊，需要记录三种用品。建立 Item、Quantity、Unit cost 和 Line total 四列，每种用品占一行，并将数量与单价作为独立数字输入。这比直接在每行填写最终金额更有用，因为人数或价格变化时无需重写整张表。`)
};

/**
* | output |
* | --- |
* | "Imagine that you are organizing a workshop and need to track three supplies. Create columns for Item, Quantity, Unit cost and Line total. Use one row for eac..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_5_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.5.paragraphs.0" }